{
    "roadmap": {
        "common": {
            "openAll": "Open all",
            "closeAll": "Close all",
            "openorCloseTitle": "Open/Close All accordion"
        },
        "nextGen": {
            "nextGenTitle": "NextGen IT",
            "nextGenDesc": "What is NextGen IT : Bring IT automation to end user and get the issue fixed faster.",
            "acc1Title": "In Production",
            "prodItem1": "KB Article integration : 300+ KB articles enabling IT self-resolution",
            "prodItem2": "Self-Healing Solution: More than 18 remote scripts are available to resolve the issue.",
            "prodItem3": "Incident Creation: Ensures accurate and faster resolution through automated incident logging.",
            "prodItem4": "Chat with Live agent (human agent): MyHelp allows users to chat with a human agent from AI Assistant",
            "acc2Title": "In Development",
            "devItem1": "Schedule Call back (Feb - 2026) : Schedule an IT support callback at a time that fits your availability",
            "devItem2": "Intelligent routing (Feb - 2026) : Route tickets to the correct resolver team for quicker support",
            "acc3Title": "Backlog",
            "backItem1": "PKI troubleshooting agent : MyHelp integration with the PKI troubleshooting agent to address certificate-related problems",
            "backItem2": "Schedule Walk‑in Center appointments directly through MyHelp"
        },
        "corporate": {
            "title": "Corporate",
            "desc": "The Corporate is responsible for managing enterprise corporate applications, HR platforms, that support workforce and business functions.",
            "acc1Title": "In Production",
            "prodItem1": "BU based Apps : 90+ apps with BU-based personalization",
            "prodItem2": "Custom app pinning : Users can personalize their MyHelp dashboard by pinning custom apps",
            "prodItem3": "Workplace queries : 100+ workplace queries (office, parking, buildings)",
            "prodItem4": "Meeting room booking with AI assistant : Fast, simplified meeting room booking with Gingco integration",
            "prodItem5": "HR Queries : MyHelp replies to top 50 HR queries",
            "prodItem6": "People Search : Users to search for their E.ON colleagues through MyHelp",
            "acc2Title": "In Development",
            "devItem1": "Application onboarding based on business unit rollout.",
            "devItem2": "Meeting Room AI assistant",
            "acc3Title": "In Backlog",
            "backItem1": "Add apps from AI assistant and custom Tabs : Add apps instantly through MyHelp Assistant’s suggested options"
        },
        "myGenius": {
            "title": "MyGenius",
            "desc": "This integration helps you locate relevant training and courses.",
            "acc1Title": "In Production",
            "prodItem1": "Search trainings & courses : Find relevant trainings and courses using MyHelp",
            "acc2Title": "In Development",
            "acc3Title": "In Backlog",
            "backItem1": "Personalized learning : Personalized training recommendations based on business‑unit eligibility."
        },
        "myItOrder": {
            "title": "MyIT order",
            "desc": "This integration helps you find relevant IT order items and catalogs.",
            "acc1Title": "In Production",
            "prodItem1": "Quick IT Order catalog search:  Quick search and order your IT from MyHelp",
            "prodItem2": "Software access enablement & revocation : Enable or revoke software access navigating from MyHelp.",
            "acc2Title": "In Development",
            "devItem1": "IT assets cost overview : MyHelp will display a cost overview of your IT assets",
            "acc3Title": "In Backlog",
            "backItem1": "Central Approval of ordered items"
        },
        "compass": {
            "title": "Compass",
            "desc": "This integration will help you find community, news information and announcements that are shared on the intranet.",
            "acc1Title": "In Production",
            "prodItem1": "To be released by 28th Feb 2026",
            "acc2Title": "In Development",
            "devItem1": "Compass Search (Feb – 2026) : E.ON users will be able search their community data in MyHelp E.ON Search",
            "devItem2": "MyHelp-Compass AI Assistant (in progress) (Feb – 2026) : Enabling E.ON users to access community data through the MyHelp AI Assistant",
            "acc3Title": "In Backlog"
        },
        "chatProjectData": {
            "title": "Chat with your project data",
            "desc": "This integration allow you to onboard your project data from confluence, sharepoint etc.",
            "acc1Title": "In Production",
            "prodItem1": "Confluence One Billing and DSODP projects are onboarded",
            "prodItem2": "SharePoint sites – DSODP project site is onboarded",
            "acc2Title": "In Development",
            "devItem1": "Work on integrating the Nautilus project data is currently underway.",
            "acc3Title": "In Backlog"
        },
        "personalization": {
            "title": "Personalization",
            "acc1Title": "In Production",
            "prodItem1": "Multi-lingual : supports 4 languages (English, Deutsch, Svenska, Română)",
            "prodItem2": "Multi-theme : allows each business unit or region to use its own branding, improving familiarity and adoption.",
            "prodItem3": "5 additional new languages under beta profile (Čeština, Italiano, Magyar, Nederlands and Polski)",
            "acc2Title": "In Development",
            "devItem1": "Data source–specific: (15th Feb – 2026): provides more targeted and context-aware answers by pulling information from the user's selected data sources.",
            "acc3Title": "In Backlog"
        },
        "technicalEnablement": {
            "title": "Technical Enablement",
            "acc1Title": "In Production",
            "prodItem1": "Security & Observability ensure enterprise-grade data protection, compliance and performance, and also enabling safe, reliable, and smooth run of operations",
            "prodItem2": "KPI & adoption dashboards (Power BI)<br /> Delivers clear visibility into usage, value realization, and business impact through KPI dashboards",
            "acc2Title": "In Development",
            "devItem1": "Multiagent workflow by 15th March 2026 : Enables more intent driven conversations that not only improve answer relevance but also execute end to end for users.",
            "acc3Title": "In Backlog",
            "backItem1": "MCP framework (Backlog): <br /> Provides a foundation to orchestrate and coordinate AI agents across E.ON, enabling scalable and collaborative enterprise AI capabilities."
        }
    }
}